<template>
  <div class="similar__products">
    <div class="similar_product_title">
      <h1 class="font-bold flex"><feather-icon icon="GridIcon" svgClasses="mr-2" />Similar Products</h1>
    </div>

    <hr />

    <div class="similar_prducts">
      <div class="grid gap-4">
        <div class="product min-w-full flex h-64 rounded-lg overflow-hidden shadow-md mt-8 p-5" v-for="(product, index) in products" :key="index">
          <div class="product__image w-1/3 mr-5">
            <img class="ml-auto mr-auto w-full h-full object-cover" src="@/assets/images/products/pr_default.jpg" />
          </div>
          <div class="product__details w-2/3 relative">
            <div class="product__title mt-5">
              <router-link
                :to="{
                  name: 'marketlist-view-product',
                  params: {
                    id: product.products_id
                  }
                }"
                v-slot="{ href }"
              >
                <a :href="href"
                  ><h2 class="mb-2 font-semibold">{{ product.products_product_name }}</h2></a
                >
              </router-link>
            </div>
            <div class="product__details">
              <router-link
                :to="{
                  name: 'marketlist-view-sellerProducts',
                  params: {
                    id: product.parent_users_id
                  }
                }"
                v-slot="{ href }"
                replace
              >
                <a :href="href" class="text-black">
                  <p class="mt-2"><span class="font-bold">Sold By</span> {{ product.parent_users_business_name ? product.parent_users_business_name : product.parent_users_username }}</p>
                </a>
              </router-link>
              <p class="mt-2 text-black"><span class="font-bold">Category</span> {{ product.category_category_name }}</p>
              <p class="mt-2 text-black"><span class="font-bold">Sales Price</span> $ {{ product.products_sales_price | currencyFilter }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { weightMixins } from '@/utils/weightType'
import { paymentMixins } from '@/utils/paymentTypes'

export default {
  name: 'SimilarProducts',

  props: {
    products: Array
  },

  mixins: [weightMixins, paymentMixins],

  filters: {
    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    },

    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(Number(value), 3)
    }
  }
}
</script>

<style lang="scss">
.similar__products {
  .grid {
    grid-auto-rows: 230px;
    grid-template-columns: repeat(auto-fill, minmax(600px, 1fr)) !important;
  }

  .product {
    img {
      border: 1px solid #d2d2d2;
    }

    .product__details {
      h2:hover {
        color: #008000 !important;
      }
      a:hover {
        text-decoration: underline;
        text-decoration-color: #008000;
      }
    }
  }
}

@media (min-width: 600px) {
  .similar__products .grid {
    grid-template-columns: repeat(auto-fill, minmax(600px, 1fr)) !important;
  }
}

@media (min-width: 900px) {
  .similar__products .grid {
    grid-template-columns: repeat(auto-fill, minmax(600px, 1fr)) !important;
  }
}
</style>